import React, { useEffect, useState } from "react";
import "./manageColumnSet.scss";
import userService from "../../../../services/user.service";
import { CircularProgress } from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import CustomSearch from "../../../../Common/CustomSearch";
import DialogBox from "../../Popups/ReusablePopup/DialogBox";
import { useDispatch, useSelector } from "react-redux";
import AddIcon from "@material-ui/icons/Add";
import CreateSet from "./CreateColumnSet";
import {
  openConfirmationPopup,
  openFailDialog,
  openSuccessPopup,
  openRenamePopup,
} from "../../../../Redux/Actions/PopupActions";
import {
  setActiveBreakdownForColumnSetSelected,
  setSelectedColumnSet,
  setSeasonInfoOfTable,
} from "../../../../Redux/Actions/VideoLibraryDataTableActions";
import {
  toggleCreateColumnSet,
  setColumnSetStatusData,
  setBreakdownColumnSetData,
} from "../../../../Redux/Actions/ColumnSetAction";
import ListMenu from "../../../../Common/ListMenu";
import DeleteIcon from "@mui/icons-material/Delete";
import { FaEdit } from "react-icons/fa";
import { getFromLocalStorage } from "../../../../utils/webStorage";

const ManageColumnSet = (props) => {
  const [open, setOpen] = useState(false);
  const [columnSetForSave, setColumnSetForSave] = useState("");
  const [hiddenColumnSearched, setHiddenColumnSearched] = useState(false);
  const [hiddenColumnSearchQuery, setHiddenColumnSearchQuery] = useState("");
  const [activeColumnSearched, setActiveColumnSearched] = useState(false);
  const [activeColumnSearchQuery, setActiveColumnSearchQuery] = useState("");
  const [isDragDisabled, setIsDragDisabled] = useState(false);
  const [isDragDrop, setIsDragDrop] = useState(false);
  const [allColumnSearchQuery, setAllColumnSearchQuery] = useState("");
  const [allColumnDataSearched, setAllColumnDataSearched] = useState(false);
  const { selectedColumnSet, tableSeasonInfo } = useSelector(
    (state) => state?.VideoLibraryDataTable
  );
  const { columnSetStatusData } = useSelector((state) => state?.ColumnSetData);
  const loginRole = getFromLocalStorage("loginRole");
  const userEmail = JSON.parse(getFromLocalStorage("user"))["userProfile"][
    "email"
  ];
  const dispatch = useDispatch();
  const [columns, setColumns] = useState({
    ["0"]: {
      name: "Column Set",
      items: [],
      loading: false,
    },
    ["1"]: {
      name: "Hidden Columns",
      items: [],
      loading: false,
    },
    ["2"]: {
      name: "Active Columns",
      items: [],
      loading: false,
    },
  });
  const [error, setError] = useState({
    errorHiddenBreakDown: "",
    errorActiveBreakDown: "",
    errorShiftNext: "",
    errorShiftPrev: "",
  });
  const { schoolId } = props;

  const handleButtonClick = (column) => {
    setColumnSetForSave({ columnName: column?.columnName, id: column?.id });
    setColumns((prevState) => ({
      ...prevState,
      1: { ...prevState["1"], loading: true },
      2: { ...prevState["2"], loading: true },
    }));

    userService
      .getAllBreakdownsByColumnSetName(schoolId, column?.id)
      .then((res) => {
        const { breakdownMap, columnNameList } = res.data.data;
        const activeBreakdowns =
          breakdownMap[column?.columnName]?.activeBreakdowns || [];
        const hiddenBreakdowns =
          breakdownMap[column?.columnName]?.hiddenBreakdowns || [];

        const sortBreakdowns = (breakdowns) =>
          breakdowns.sort(
            (a, b) => parseInt(a.positionNumber) - parseInt(b.positionNumber)
          );

        const filteredActiveData = sortBreakdowns(activeBreakdowns).map(
          (el) => ({ ...el, id: el.id.toString() })
        );
        const filteredHiddenData = sortBreakdowns(hiddenBreakdowns).map(
          (el) => ({ ...el, id: el.id.toString() })
        );

        setColumns((prevState) => ({
          ...prevState,
          1: { ...prevState["1"], items: filteredHiddenData, loading: false },
          2: { ...prevState["2"], items: filteredActiveData, loading: false },
        }));
      })
      .catch((error) => {
        setColumns((prevState) => ({
          ...prevState,
          1: { ...prevState["1"], items: [], loading: false },
          2: { ...prevState["2"], items: [], loading: false },
        }));
        setError((prevError) => ({
          ...prevError,
          errorActiveBreakDown: error.message,
        }));
      });
  };

  const getAllColumnSetData = async () => {
    try {
      setColumns((prevState) => ({
        ...prevState,
        0: { ...prevState["0"], loading: true },
        1: { ...prevState["1"], loading: true },
        2: { ...prevState["2"], loading: true },
      }));

      const res = await userService.getAllBreakDownColumnData(schoolId);
      const { breakdownMap, columnNameList } = res?.data?.data;
      const defaultColumn = columnNameList?.find((el) => el?.isDefaultColumn);

      setSelectedColumnSet(dispatch, {
        id: defaultColumn?.id,
        columnName: defaultColumn?.columnName,
      });

      const sortAndMapBreakdowns = (breakdowns) =>
        breakdowns
          .map((el) => ({ ...el, id: el?.id?.toString() }))
          .sort(
            (a, b) => parseInt(a.positionNumber) - parseInt(b.positionNumber)
          );

      const filteredHiddenData = sortAndMapBreakdowns(
        breakdownMap[defaultColumn?.columnName]?.hiddenBreakdowns || []
      );
      const filteredActiveData = sortAndMapBreakdowns(
        breakdownMap[defaultColumn?.columnName]?.activeBreakdowns || []
      );

      setColumns((prevState) => ({
        ...prevState,
        0: { ...prevState["0"], items: columnNameList, loading: false },
        1: { ...prevState["1"], items: filteredHiddenData, loading: false },
        2: { ...prevState["2"], items: filteredActiveData, loading: false },
      }));

      setColumnSetStatusData(dispatch, columnNameList);
      setBreakdownColumnSetData(dispatch, breakdownMap);
      setActiveBreakdownForColumnSetSelected(dispatch, filteredActiveData);
    } catch (error) {
      setColumns((prevState) => ({
        ...prevState,
        0: { ...prevState["0"], items: [], loading: false },
        1: { ...prevState["1"], items: [], loading: false },
        2: { ...prevState["2"], items: [], loading: false },
      }));
      setError((prev) => ({ ...prev, errorActiveBreakDown: error.message }));
    }
  };

  const getAllColumnSetDataWhenSearchIsEmpty = async () => {
    setColumns((prevState) => ({
      ...prevState,
      0: {
        ...prevState["0"],
        loading: true,
      },
    }));
    const columnSet = columnSetForSave || selectedColumnSet;
    userService
      .getAllBreakdownsByColumnSetName(schoolId, columnSet?.id)
      .then((res) => {
        const { columnNameList } = res.data.data;
        setColumns((prevState) => ({
          ...prevState,
          0: {
            ...prevState["0"],
            items: columnNameList,
            loading: false,
          },
        }));
      })
      .catch((err) => {
        setError((prev) => ({ ...prev, errorActiveBreakDown: error.message }));
        setColumns((prevState) => ({
          ...prevState,
          0: {
            ...prevState["0"],
            items: [],
            loading: false,
          },
        }));
      });
  };

  const getHiddenColumnDataWhenSearchIsEmpty = async () => {
    try {
      setColumns((prevState) => ({
        ...prevState,
        1: { ...prevState["1"], loading: true },
      }));

      const columnSet = columnSetForSave || selectedColumnSet;
      const res = await userService.getHiddenBreakDown(schoolId, columnSet?.id);
      const { breakdowns } = res?.data?.data;
      const sortAndMapHiddenBreakdowns = (breakdowns) =>
        breakdowns
          .map((el) => ({ ...el, id: el.id.toString() }))
          .sort(
            (a, b) => parseInt(a?.positionNumber) - parseInt(b?.positionNumber)
          );

      const filteredHiddenData = sortAndMapHiddenBreakdowns(breakdowns);

      setColumns((prevState) => ({
        ...prevState,
        1: { ...prevState["1"], items: filteredHiddenData, loading: false },
      }));
    } catch (error) {
      setError((prev) => ({ ...prev, errorActiveBreakDown: error.message }));
      setColumns((prevState) => ({
        ...prevState,
        1: { ...prevState["1"], items: [], loading: false },
      }));
    }
  };

  const getActiveColumnDataWhenSearchIsEmpty = async () => {
    try {
      setColumns((prevState) => ({
        ...prevState,
        2: { ...prevState["2"], loading: true },
      }));

      const columnSet = columnSetForSave || selectedColumnSet;
      const res = await userService.getActiveBreakDown(schoolId, columnSet?.id);
      const { breakdowns } = res?.data?.data;
      const sortAndMapActiveBreakdowns = (breakdowns) =>
        breakdowns
          .map((el) => ({ ...el, id: el?.id?.toString() }))
          .sort(
            (a, b) => parseInt(a?.positionNumber) - parseInt(b?.positionNumber)
          );

      const filteredActiveData = sortAndMapActiveBreakdowns(breakdowns);

      setColumns((prevState) => ({
        ...prevState,
        2: { ...prevState["2"], items: filteredActiveData, loading: false },
      }));
    } catch (error) {
      setError((prev) => ({ ...prev, errorActiveBreakDown: error.message }));
      setColumns((prevState) => ({
        ...prevState,
        2: { ...prevState["2"], items: [], loading: false },
      }));
    }
  };

  const sortArrayOfObject = (list) => {
    const newSortedData = list.sort(
      (a, b) => parseInt(a.positionNumber) - parseInt(b.positionNumber)
    );
    return newSortedData;
  };

  useEffect(async () => {
    if (open) {
      await getAllColumnSetData();
    }
  }, [open]);

  const resetAllStateData = () => {
    setIsDragDrop(false);
    setAllColumnSearchQuery("");
    setHiddenColumnSearchQuery("");
    setActiveColumnSearchQuery("");
    setColumnSetForSave("");
  };

  const closePopup = () => {
    setOpen(false);
    resetAllStateData();
  };

  const openPopup = () => {
    setOpen(true);
  };

  const searchAllBreakdownColumn = async (query) => {
    try {
      setAllColumnSearchQuery(query);
      if (!allColumnDataSearched) {
        setAllColumnDataSearched(true);
      }
      setColumns((prevState) => ({
        ...prevState,
        0: {
          ...prevState["0"],
          loading: true,
        },
      }));
      const response = await userService.searchColumnSet(query, schoolId);
      setColumns((prevState) => ({
        ...prevState,
        0: {
          ...prevState["0"],
          items: response?.data?.data?.content,
          loading: false,
        },
      }));
    } catch (error) {
      setColumns((prevState) => ({
        ...prevState,
        0: {
          ...prevState["0"],
          items: [],
          loading: false,
        },
      }));
      setError((prev) => ({ ...prev, errorActiveBreakDown: error.message }));
    }
  };

  const searchHiddenColumn = (searchString) => {
    setHiddenColumnSearchQuery(searchString);
    if (!hiddenColumnSearched) {
      setHiddenColumnSearched(true);
    }
    setColumns((prevState) => ({
      ...prevState,
      1: {
        ...prevState["1"],
        loading: true,
      },
    }));
    userService
      .searchHiddenColumn(
        searchString,
        schoolId,
        columnSetForSave ? columnSetForSave?.id : selectedColumnSet?.id
      )
      .then((response) => {
        setColumns((prevState) => ({
          ...prevState,
          1: {
            ...prevState["1"],
            items: response?.data?.data?.breakdowns,
            loading: false,
          },
        }));
      })
      .catch((error) => {
        setColumns((prevState) => ({
          ...prevState,
          1: {
            ...prevState["1"],
            items: [],
            loading: false,
          },
        }));
        setError((prev) => ({ ...prev, errorActiveBreakDown: error.message }));
      });
  };

  const searchActiveColumn = (searchString) => {
    setActiveColumnSearchQuery(searchString);
    if (!activeColumnSearched) {
      setActiveColumnSearched(true);
    }
    setColumns((prevState) => ({
      ...prevState,
      2: {
        ...prevState["2"],
        loading: true,
      },
    }));
    userService
      .searchActiveColumnBreakdown(
        searchString,
        schoolId,
        columnSetForSave ? columnSetForSave?.id : selectedColumnSet?.id
      )
      .then((response) => {
        setColumns((prevState) => ({
          ...prevState,
          2: {
            ...prevState["2"],
            items: response?.data?.data?.breakdowns,
            loading: false,
          },
        }));
      })
      .catch((error) => {
        setColumns((prevState) => ({
          ...prevState,
          2: {
            ...prevState["2"],
            items: [],
            loading: false,
          },
        }));
        setError((prev) => ({ ...prev, errorActiveBreakDown: error.message }));
      });
  };

  const onDragEnd1 = (result, columns, setColumns) => {
    const { source, destination } = result;
    setIsDragDrop(true);
    setIsDragDisabled(true);
    if (!result.destination) {
      setIsDragDrop(false);
      setIsDragDisabled(false);
      return;
    }

    if (source.droppableId !== destination.droppableId) {
      const sourceColumn = columns[source.droppableId];
      const destColumn = columns[destination.droppableId];
      const sourceItems = [...sourceColumn.items];
      const destItems = [...destColumn.items];
      //modified the original array directly
      const [removed] = sourceItems.splice(source.index, 1);
      destItems.splice(destination.index, 0, removed);
      const updatedColumns = {
        ...columns,
        [source.droppableId]: {
          ...sourceColumn,
          items: sourceItems,
        },
        [destination.droppableId]: {
          ...destColumn,
          items: destItems,
        },
      };
      if (result.destination.droppableId === "2") {
        const breakDownId1 = columns["1"].items[result.source.index].id;

        if (columns["2"].items.length === 0) {
          userService
            .activeToHiddenCall([breakDownId1], true, null, null, breakDownId1)
            .then(() => {
              setIsDragDrop(true);
              setIsDragDisabled(false);
            })
            .catch((err) => {
              setIsDragDrop(true);
              setIsDragDisabled(false);
            });
        } else {
          const breakDownListOfIdAndPositionNumber = updatedColumns[
            "2"
          ].items.map((item, index) => ({
            breakdownId: item.id,
            positionNumber: index,
          }));
          userService
            .activeToHiddenCall([breakDownId1], true, null, null, breakDownId1)
            .then((res) => {
              userService
                .activeColumnsDragAndDrop(breakDownListOfIdAndPositionNumber)
                .then(() => {
                  setIsDragDrop(true);
                  setIsDragDisabled(false);
                })
                .catch(() => {
                  setIsDragDrop(true);
                  setIsDragDisabled(false);
                });
            })
            .catch((err) => {
              setIsDragDrop(true);
              setIsDragDisabled(false);
            });
        }
      } else {
        const breakDownId1 = columns["2"].items[result.source.index].id;

        if (columns["1"].items.length === 0) {
          userService
            .InactiveToHiddenCall(
              [breakDownId1],
              false,
              null,
              null,
              breakDownId1
            )
            .then((res) => {
              setIsDragDrop(true);
              setIsDragDisabled(false);
            })
            .catch((err) => {
              setIsDragDrop(false);
              setIsDragDisabled(false);
            });
        } else {
          const breakDownListOfIdAndPositionNumber = updatedColumns[
            "1"
          ].items.map((item, index) => ({
            breakdownId: item.id,
            positionNumber: index,
          }));
          userService
            .InactiveToHiddenCall(
              [breakDownId1],
              false,
              null,
              null,
              breakDownId1
            )
            .then((res) => {
              userService
                .hiddenColumnDragAndDrop(breakDownListOfIdAndPositionNumber)
                .then(() => {
                  setIsDragDrop(true);
                  setIsDragDisabled(false);
                })
                .catch(() => {
                  setIsDragDrop(true);
                  setIsDragDisabled(false);
                });
            })
            .catch((err) => {
              setIsDragDrop(true);
              setIsDragDisabled(false);
            });
        }
      }
      setColumns(updatedColumns);
    } else {
      const breakDownId1 =
        columns[result.destination.droppableId].items[
          result.source.index ===
          columns[result.destination.droppableId].items.length
            ? result.source.index - 1
            : result.source.index
        ].id;
      const breakDownId2 =
        columns[result.destination.droppableId].items[result.destination.index]
          .id;
      if (breakDownId1 === breakDownId2) {
        setIsDragDrop(false);
        setIsDragDisabled(false);
        return;
      }
      const column = columns[source.droppableId];
      const copiedItems = [...column.items];
      const [removed] = copiedItems.splice(source.index, 1);
      copiedItems.splice(destination.index, 0, removed);
      const updatedColumns = {
        ...columns,
        [source.droppableId]: {
          ...column,
          items: copiedItems,
        },
      };

      setColumns(updatedColumns);

      if (result.destination.droppableId === "1") {
        const breakDownListOfIdAndPositionNumber = updatedColumns[
          "1"
        ].items.map((item, index) => ({
          breakdownId: item.id,
          positionNumber: index,
        }));
        userService
          .hiddenColumnDragAndDrop(breakDownListOfIdAndPositionNumber)
          .then(() => {
            setIsDragDrop(true);
            setIsDragDisabled(false);
          })
          .catch((err) => {
            setIsDragDrop(true);
            setIsDragDisabled(false);
          });
      } else {
        const breakDownListOfIdAndPositionNumber = updatedColumns[
          "2"
        ].items.map((item, index) => ({
          breakdownId: item.id,
          positionNumber: index,
        }));
        userService
          .activeColumnsDragAndDrop(breakDownListOfIdAndPositionNumber)
          .then(() => {
            setIsDragDrop(true);
            setIsDragDisabled(false);
          })
          .catch((err) => {
            setIsDragDrop(true);
            setIsDragDisabled(false);
          });
      }
    }
  };

  const handleSaveButtonClick = () => {
    const currentColumnSet = columnSetStatusData.filter(
      (el) => el?.columnName === columnSetForSave?.columnName
    );

    if (columnSetForSave) {
      userService
        .updateDefaultColumnBreakdown(schoolId, currentColumnSet[0]?.id)
        .then((res) => {
          setSeasonInfoOfTable(
            dispatch,
            {
              selectedSeasonInfo: {
                ...tableSeasonInfo,
              },
            },
            tableSeasonInfo
          );
          openSuccessPopup(dispatch, {
            successPopUp: {
              message: "Breakdown column set saved successfully!",
              open: true,
            },
          });
          setOpen(false);
          resetAllStateData();
        })
        .catch((err) => {
          openFailDialog(dispatch, {
            open: true,
            message: "Something went wrong!",
          });
        });
    } else {
      setSeasonInfoOfTable(
        dispatch,
        {
          selectedSeasonInfo: {
            ...tableSeasonInfo,
          },
        },
        tableSeasonInfo
      );
      openSuccessPopup(dispatch, {
        successPopUp: {
          message: "Breakdown column set saved successfully!",
          open: true,
        },
      });
      setOpen(false);
      resetAllStateData();
    }
  };

  const menuItemContent = (column) => {
    const notDeleted = [
      {
        id: "1",
        name: "Delete",
        icon: <DeleteIcon className="manage-section-iconss delete-icon" />,
        ApiCall: () => deleteRequestDialog(column),
      },
      {
        id: "2",
        name: "Rename",
        icon: (
          <FaEdit
            className="manage-section-iconss"
            style={{ marginLeft: "5px" }}
          />
        ),
        ApiCall: () => renameColumnSetDialog(column),
      },
    ];
    return notDeleted;
  };

  const deleteRequestDialog = (column) => {
    if (column?.id === selectedColumnSet.id) {
      openSuccessPopup(dispatch, {
        successPopUp: {
          message: "Please note that the default column set cannot be deleted.",
          open: true,
          isWarningPopUp: true,
        },
      });
    } else {
      openConfirmationPopup(dispatch, {
        confirmationPopup: {
          open: true,
          message: "Are You Sure You Want To Delete This Column Set?",
          btnColor: "red",
          btnText: "Delete",
          type: "Delete Column Set",
          data: column,
        },
        confirmationAction: async () => {
          await getAllColumnSetData();
        },
      });
    }
  };

  const renameColumnSetDialog = (column) => {
    openRenamePopup(dispatch, {
      renamePopup: {
        open: true,
        fieldToShow: "eventMediaCategory",
        type: "Rename Column Set",
        id: column?.id,
        schoolId: schoolId,
      },
      renameAction: async () => {
        await getAllColumnSetData();
      },
    });
  };

  return (
    <div>
      <button className="small-btn fs-16" onClick={() => openPopup()}>
        Columns
      </button>

      <DialogBox
        open={open}
        onClose={() => closePopup()}
        variant="md"
        title={
          <div className="d-flex-space-between">
            <p className="bold">Manage Column Set</p>
            <button
              className="breakdownTableCloseIcon"
              onClick={() => closePopup()}
            >
              <span>&times;</span>
            </button>
          </div>
        }
      >
        <button
          type="submit"
          className="addBtnn2 mng-padding"
          onClick={() => toggleCreateColumnSet(dispatch, true)}
        >
          <AddIcon className="mr-2 addIconSc " />
          {""}Create New Column Set
        </button>

        <div className="clear20" />
        <div className={`d-flex gap-20 ${isDragDisabled && ""}`}>
          {isDragDisabled && (
            <div className="position-absolute">
              <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
                <CircularProgress
                  className="rounded-circle"
                  color="success"
                  sx={{ fontSize: 10, color: "#002244" }}
                  disableShrink
                />
              </div>
            </div>
          )}
          <DragDropContext
            onDragEnd={(result) => onDragEnd1(result, columns, setColumns)}
          >
            {/* code start */}
            <div className="columnSetBoxes-main position-relative">
              {columns[0].loading && (
                <div className="hidden-active-column-loading-container">
                  <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
                    <CircularProgress
                      className="rounded-circle"
                      color="success"
                      sx={{ fontSize: 10, color: "#002244" }}
                      disableShrink
                    />
                  </div>
                </div>
              )}
              {!columns[0]?.loading && columns[0]?.items?.length === 0 && (
                <div className="hidden-active-column-loading-container">
                  <p className="text-center bold fs-16">{`No ${columns[0]?.name} Found`}</p>
                </div>
              )}
              <div className="active-hidden-column-header">
                <h6 className="fs-22 semi-bold txt-center white">
                  {columns[0]?.name}
                </h6>
                <div className="clear10"></div>
                <CustomSearch
                  searchQuery={allColumnSearchQuery}
                  setSearchQuery={setAllColumnSearchQuery}
                  isVideoLibraryPage={true}
                  searchData={searchAllBreakdownColumn}
                  getDataByPage={getAllColumnSetDataWhenSearchIsEmpty}
                  searchedRecord={allColumnDataSearched}
                  setSearchedRecord={setAllColumnDataSearched}
                />
              </div>
              <div className="active-hidden-column-container">
                <div
                  className={`active-hidden-column-draggable-container    }`}
                >
                  {columns[0]?.items?.map((column) => (
                    <div
                      key={column?.id}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "6px 10px 6px 10px",
                      }}
                      className={`active-hidden-column-draggable-item ${
                        columnSetForSave
                          ? columnSetForSave?.columnName === column?.columnName
                            ? "isButtonSelect"
                            : ""
                          : selectedColumnSet?.columnName === column?.columnName
                          ? "isButtonSelect"
                          : ""
                      }`}
                      onClick={() => handleButtonClick(column)}
                    >
                      {column?.columnName}
                      {(loginRole === "SCHOOL ADMIN" ||
                        userEmail === column?.createdBy) && (
                        <ListMenu menuContent={menuItemContent(column)} />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {Object.entries(columns).map(([id, column]) => {
              return (
                id != 0 && (
                  <div className="columnSetBoxes-main position-relative">
                    {column.loading && (
                      <div className="hidden-active-column-loading-container">
                        <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
                          <CircularProgress
                            className="rounded-circle"
                            color="success"
                            sx={{ fontSize: 10, color: "#002244" }}
                            disableShrink
                          />
                        </div>
                      </div>
                    )}
                    {!column?.loading && column?.items?.length === 0 && (
                      <div className="hidden-active-column-loading-container">
                        <p className="text-center bold fs-16">{`No ${column?.name} Found`}</p>
                      </div>
                    )}
                    <div className="active-hidden-column-header">
                      <h6 className="fs-22 semi-bold txt-center white">
                        {column?.name}
                      </h6>
                      <div className="clear10"></div>
                      <CustomSearch
                        searchQuery={
                          column?.name === "Hidden Columns"
                            ? hiddenColumnSearchQuery
                            : activeColumnSearchQuery
                        }
                        setSearchQuery={
                          column?.name === "Hidden Columns"
                            ? setHiddenColumnSearchQuery
                            : setActiveColumnSearchQuery
                        }
                        isVideoLibraryPage={true}
                        searchData={
                          column?.name === "Hidden Columns"
                            ? searchHiddenColumn
                            : searchActiveColumn
                        }
                        getDataByPage={
                          column?.name === "Hidden Columns"
                            ? getHiddenColumnDataWhenSearchIsEmpty
                            : getActiveColumnDataWhenSearchIsEmpty
                        }
                        searchedRecord={
                          column?.name === "Hidden Columns"
                            ? hiddenColumnSearched
                            : activeColumnSearched
                        }
                        setSearchedRecord={
                          column?.name === "Hidden Columns"
                            ? setHiddenColumnSearched
                            : setActiveColumnSearched
                        }
                      />
                    </div>
                    <div className="active-hidden-column-container">
                      <Droppable droppableId={id}>
                        {(provided, snapshot) => {
                          return (
                            <div
                              className={`active-hidden-column-draggable-container ${
                                snapshot.isDraggingOver && "isDraggingOver"
                              }`}
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                            >
                              {column?.items?.map((item, index) => {
                                return (
                                  <>
                                    <Draggable
                                      key={item?.id}
                                      draggableId={item?.id}
                                      index={index}
                                      isDragDisabled={isDragDisabled}
                                    >
                                      {(provided, snapshot) => {
                                        return (
                                          <div
                                            className={`active-hidden-column-draggable-item ${
                                              snapshot.isDragging &&
                                              "isDragging"
                                            }`}
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={{
                                              ...provided.draggableProps.style,
                                            }}
                                          >
                                            {item?.breakdownName}
                                          </div>
                                        );
                                      }}
                                    </Draggable>
                                  </>
                                );
                              })}
                              {provided.placeholder}
                            </div>
                          );
                        }}
                      </Droppable>
                    </div>
                  </div>
                )
              );
            })}
          </DragDropContext>
        </div>
        <div
          className="d-flex-space-between"
          style={{ marginTop: "20px", justifyContent: "flex-end" }}
        >
          <button onClick={handleSaveButtonClick} className="small-btn fs-16">
            Save This Set
          </button>
        </div>
      </DialogBox>
      <CreateSet setColumns={setColumns} columns={columns} />
    </div>
  );
};

export default ManageColumnSet;
